<template>
  <div class="sqlb">
    <div v-show="!dialogFormVisible" class="jkhclb">
      <div class="headershenqing">
        <div class="headershenqinginside">
          <el-form
            :model="searchForm"
            class="demo-form-inline"
            style="display: flex; height: 39px"
            label-width="90px"
            label-position="left"
          >
            <el-form-item label="许可证编号:" prop="xkzBh">
              <el-input
                v-model="searchForm.xkzBh"
                placeholder="请输入"
              />
            </el-form-item>

            <el-form-item label="申请日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="开始时间"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px" prop="zt">
              <el-select v-model="searchForm.zt" placeholder="请选择" clearable>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label-width="0px">
              <div style="display: flex">
                <el-button
                  type="primary"
                  round
                  icon="el-icon-search"
                  @click="handleCurrentChange(1)"
                >搜索</el-button>
                <el-button
                  round
                  icon="el-icon-refresh-right"
                  @click="reset"
                >重置</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tableGMZ">
        <div class="tableinside">
          <div class="addmessheader">
            <el-button
              v-preventReClick
              type="primary"
              icon="el-icon-plus"
              class="addmess"
              size="mini"
              @click="addMes"
            >申请</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              class="addmessedit"
              size="mini"
              @click="addEditMes"
            >复制新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-upload"
              size="mini"
              class="addmessedit"
              @click="dcexcel"
            >导出</el-button>
          </div>

          <el-table
            ref="jkhcTable"
            :data="tableData"
            style="width: 100%"
            border
            :cell-style="typeStyle"
            show-overflow-tooltip
            @selection-change="handleSelectionChange"
            @select-all="checkSelect"
          >
            <el-table-column type="selection" align="center" :max="1" :min="1" />

            <el-table-column
              label="许可证编号"
              align="center"
              show-overflow-tooltip
              width="200"
            >
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.xkzBh }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="化学品名称"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.hxpMc }}</span>
              </template>
            </el-table-column>
            <el-table-column label="进口数量" align="center">
              <template slot-scope="scope">
                <span
                  size="medium"
                >{{ scope.row.hzsl + "("
                }}{{ scope.row.hzslDwMc + ")" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="用途" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.yt }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="出口单位"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.xsdwMc }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="申请时间"
              align="center"
              prop="cjsj"
              show-overflow-tooltip
            />
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.ztMc }} </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250px" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  size="mini"
                  type="primary"
                  icon="el-icon-view"
                  style="width: 65px; padding: 7px 9px"
                  @click="handleSelect(scope.$index, scope.row)"
                >查看</el-button>

                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  style="width: 65px; padding: 7px 9px"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-close"
                  style="
                    background: #ff4c00;
                    color: #fff;
                    width: 65px;
                    padding: 7px 9px;
                  "
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
                <el-button
                  v-if="scope.row.zt == '12'"
                  v-preventReClick
                  size="mini"
                  style="
                    background: #4170ff;
                    color: #fff;
                    width: 65px;
                    padding: 7px 9px;
                  "
                  @click="handlehexiao(scope.$index, scope.row)"
                >核销</el-button>

                <el-button
                  v-if="scope.row.zt == '42'"
                  v-preventReClick
                  type="primary"
                  size="mini"
                  style="background: #4170ff; padding: 7px 9px; width: 74px"
                  @click="handlecancel(scope.$index, scope.row)"
                >取消核销</el-button>
                <el-button
                  v-if="scope.row.zt == '12'"
                  v-preventReClick
                  size="mini"
                  type="primary"
                  style="width: 65px; padding: 7px 9px"
                  @click="handledy(scope.$index, scope.row)"
                >打印</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <jkhc-dialog
      v-if="dialogFormVisible"
      ref="dialogjkhc"
      :jkhctype="type"
      :leixing="liexing"
      @close-dialog="closeDialog"
    />
  </div>
</template>
<script>
// 获取接口地址
import {
  getkv, downloadPdf
} from '@/assets/js/common.js'
import JkhcDialog from './jkhcDialog.vue'
import { getJKHCList, getJKHC, excelwriter, deleteJKHC, writeOffJKHC, getCredentials } from '@/assets/js/jkhc.js'
export default {
  name: 'Jkhclb',
  components: { JkhcDialog },
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.sqJs) {
            return time.getTime() > new Date(this.searchForm.sqJs).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.sqKs) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.sqKs).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      buttonVisible: false, // 按钮状态的弹窗
      buttontitle: '', // 按钮状态的标题
      // 搜索条件
      searchForm: {
        hczt: '', // 核查的时候加这个状态
        xkzBh: '',
        zt: '',
        beginTime: '',
        endTime: '',
        tcdwMc: ''
      },
      type: false, // 添加和编辑，可编辑，查看不可编辑
      multipleSelection: [], // 多选选中数据
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      tableData: [], // 表格数据
      total: 0, // 总条数
      dialogFormVisible: false, // 两个组件的切换
      detailMes: {}, // 编辑或查看每条数据的信息
      options: [],
      rowid: '',
      liexing: ''
    }
  },
  created() {
    getkv('yzd_xkz_zt').then((e) => {
      this.options = e.data.data
    })
    // 获取列表信息
    this.search()

    // 根据通知提醒页面跳转携带的参数判断跳转
    if (this.$route.params.id) {
      this.search()
    }
  },
  methods: {
    reset() {
      this.searchForm = {
        hczt: '', // 核查的时候加这个状态
        xkzBh: '',
        zt: '',
        beginTime: '',
        endTime: '',
        tcdwMc: ''
      }
    },
    // 根据状态改变单元格字体颜色
    typeStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 7) {
        switch (row.zt) {
          case '00': // 草稿
            cellStyle = 'color:#333;font-weight:bold '
            break
          case '11': // 审批中
            cellStyle = 'color:#43A4E2;font-weight:bold '
            break
          case '12': // 已通过
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '13': // 不通过
            cellStyle = 'color:red;font-weight:bold '
            break
          case '22': // 已撤销
            cellStyle = 'color:red;font-weight:bold '
            break
          case '42': // 已核销
            cellStyle = 'color:red;font-weight:bold '
            break
          case '43': // 取消核销中
            cellStyle = 'color:red;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    checkSelect(selection) {
      this.$refs.jkhcTable.clearSelection()
    },
    // 获取购买申请表信息
    loadData(dataObj) {
      getJKHCList(dataObj).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 点击搜索时
    search() {
      this.loadData({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      })
    },
    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.jkhcTable.clearSelection()
        this.$refs.jkhcTable.toggleRowSelection(val.pop())
      }
    },
    // 编辑
    handleEdit(index, row) {
      this.getDetail(row.id) // 根据id获取详细信息
      this.type = false
      this.liexing = 'edit'
    },
    // 根据列表id获取每条详细信息
    async getDetail(data, type) {
      var ret = await getJKHC(data)
      var res = this.liexing == 'view' ? await getCredentials(data) : ''
      this.detailMes = ret.data.data
      this.dialogFormVisible = true

      this.$nextTick(() => {
        this.$refs.dialogjkhc.getformMes(this.detailMes, type)
        this.liexing == 'view'
          ? this.$refs.dialogjkhc.getsphjMess(res.data.data)
          : ''
      })
    },
    // 查看
    async handleSelect(index, row) {
      this.getDetail(row.id)
      this.liexing = 'view'
      this.type = true
    },
    // 打印
    handledy(index, row) {
      window.location.href = downloadPdf(row.xkzBh, row.id)
    },
    // 点击复制新增
    addEditMes() {
      // 只有选中为一行才可新增
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'info',
          message: '请选择一条数据'
        })
        return
      }
      this.getDetail(this.multipleSelection[0].id) // 根据id获取详细信息
      this.type = false
      this.liexing = 'copy'
    },
    // 点击申请按钮
    addMes() {
      this.dialogFormVisible = true
      this.type = false
      this.liexing = 'sq'
    },
    // 点击导出按钮
    dcexcel() {
      excelwriter(this.searchForm).then((e) => {
        const table = '购买证报表'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 核销
    handlehexiao(index, row) {
      this.rowid = row.id
      this.$confirm('是否确认核销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        writeOffJKHC(this.rowid).then((e) => {
          this.$message.success('核销成功')
          this.search()
        })
      })
    },
    // 取消核销
    handlecancel(index, row) {
      this.getDetail(row.id)
      this.type = true
      this.liexing = 'qxhx'
    },

    // 删除行数据
    handleDelete(index, row) {
      this.$confirm('确认是否删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteJKHC(row.id).then((e) => {
            this.$message.success('删除成功')
            this.search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 关闭对话框
    closeDialog() {
      this.dialogFormVisible = false // 切换组件为列表页
      this.$nextTick(() => {
        this.search()
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

.sqlb {
  margin: 0 auto;
  margin-top: 35px;

  .el-button--primary {
    color: #fff;
    background-color: #4170ff;
    border-color: #4170ff;
  }

  /deep/ .el-pagination__total {
    margin-left: 8px;
  }
  .el-pagination {
    padding: 10px 0;
    border: 1px solid #ebeef5;
    border-top: 0;
  }
  .jkhclb {
    padding-bottom: 10px;
    margin: 0 auto;
    width: 95%;
    max-width: 1503px;
    .headershenqing {
      display: flex;
      align-items: center;
      margin: 0 auto;
      height: 96px;
      background-color: #fff;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      margin-bottom: 10px;
      .headershenqinginside {
        margin: 0 auto;
        width: 90%;
        /deep/ .el-button {
          height: 39px;
          border-radius: 20px;
        }
        /deep/ .el-form-item {
          margin-bottom: 10px;
          margin-right: 30px;
        }
      }
    }

    .tableGMZ {
      background-color: #fff;
      // margin: 21px auto 57px auto;
      .tableinside {
        width: 90%;
        margin: 0 auto;
        padding: 40px 0 57px;
        /deep/ .el-table {
          z-index: 0;
        }
        /deep/ .el-table .has-gutter tr th {
          background: #f4f4f4;
        }
        .addmessheader {
          background: #f4f4f4;
          .addmess {
            margin: 12px 0 12px 8px;
          }
        }
      }
    }

    .el-dialog {
      .el-dialog__footer {
        .el-button {
          margin: 0 20px;
        }
      }
    }
  }
}
/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
</style>
